import { Form, Button } from "react-bootstrap";

interface PersonalInfoStepProps {
  cellPhone: string;
  name: string;
  lastName: string;
  email: string;
  documentNumber: string;
  setCellPhone: (value: string) => void;
  setName: (value: string) => void;
  setLastName: (value: string) => void;
  setEmail: (value: string) => void;
  setDocumentNumber: (value: string) => void;
  handleFetchClient: () => void;
  handleNext: () => void;
}

const PersonalInfoStep = ({
  cellPhone,
  name,
  lastName,
  email,
  documentNumber,
  setCellPhone,
  setName,
  setLastName,
  setEmail,
  setDocumentNumber,
  handleFetchClient,
  handleNext,
}: PersonalInfoStepProps) => {
  return (
    <div className="col-md-6">
      <h2>Datos Personales</h2>
      <Form.Group>
        <Form.Label>
          Ingresá tu número de WhatsApp (sin 15 y sin 0)
        </Form.Label>
        <Form.Control
          type="number"
          name="cellphone"
          id="cellphone"
          size="lg"
          placeholder="Ej. 3415654321"
          className="col-md-6 mb-2"
          value={cellPhone}
          onChange={(element) => setCellPhone(element.target.value)}
          onBlur={handleFetchClient}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Nombre</Form.Label>
        <Form.Control
          name="name"
          id="name"
          size="lg"
          className="col-md-6 mb-2"
          value={name}
          onChange={(element) => setName(element.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Apellido</Form.Label>
        <Form.Control
          name="last_name"
          id="last_name"
          size="lg"
          className="col-md-6 mb-2"
          value={lastName}
          onChange={(element) => setLastName(element.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          name="email"
          id="email"
          size="lg"
          className="col-md-6 mb-2"
          value={email}
          onChange={(element) => setEmail(element.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>DNI (sin puntos y sin espacios)</Form.Label>
        <Form.Control
          type="number"
          name="document_number"
          id="document_number"
          size="lg"
          className="col-md-6 mb-2"
          value={documentNumber}
          onChange={(element) => setDocumentNumber(element.target.value)}
        />
      </Form.Group>
      <p className="text-muted">*Todos los campos son requeridos</p>
      <Button
        variant="secondary btn-lg btn-block col-md-6"
        onClick={handleNext}
      >
        Siguiente
      </Button>
    </div>
  );
};

export default PersonalInfoStep;
